<template>
    <div class="login-page__wrapper" v-if="authenticationStep != 'None'">
        <div class="login-page__content">
            <WebpImage class="login-page__logo" src="/frontend/kasa-loyalty/img/static/logo.svg" alt="Sazka logo" width="82" height="82" />
            <LoginContent />
        </div>
        <div class="login-page__register">
            <span class="login-page__register-text">Nemáte svůj účet?</span>
            <a class="login-page__register-link" :href="registerLink">Registrujte se</a>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, watchEffect } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import LoginContent from "@/account/components/login/login-content.vue";
import { settings } from "@/settings";
import { UrlHelper } from "@/helpers/url-helper";
import useAuthenticationFlows, { authenticationStep } from "../composables/use-authentication-flows";
import { isUserLoggedIn } from "../use-user-account";

const { openLoginModal } = useAuthenticationFlows();

openLoginModal();

const registerLink = computed(() => settings.url.root + "?akce=registrace");

const redirectLoggedInUrl = computed(() => {
    const returnUrl = UrlHelper.getQueryString("returnurl");
    return returnUrl && !returnUrl.startsWith("//") ? returnUrl : settings.url.root;
});

const redirectLoggedIn = () => {
    window.location.href = redirectLoggedInUrl.value;
};

watchEffect(() => {
    if (isUserLoggedIn.value) {
        redirectLoggedIn();
    }
});
</script>
